import React from 'react';

const SwyperLogo = ({ className = "", width = 300, height = 130 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="-25 19 300 103" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      style={{ overflow: 'visible' }}
    >
      <defs>
        {/* Enhanced bubble effect */}
        <filter id="bubble">
          <feGaussianBlur in="SourceAlpha" stdDeviation="4"/>
          <feOffset dx="0" dy="4" result="offsetblur"/>
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.5"/>
          </feComponentTransfer>
          <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        
        {/* Shadow for Y swooshes and arrows */}
        <filter id="yShadow">
          <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.5" floodColor="#000000"/>
        </filter>
        
        {/* Glossy highlight effect for bubble letters */}
        <linearGradient id="glossy" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: 'white', stopOpacity: 0.6 }} />
          <stop offset="40%" style={{ stopColor: 'white', stopOpacity: 0.2 }} />
          <stop offset="100%" style={{ stopColor: 'black', stopOpacity: 0.15 }} />
        </linearGradient>
      </defs>

      {/* BOTTOM LAYER: Left swoosh - raised 1px to reduce white space */}
      <g filter="url(#yShadow)">
        {/* Left descender with perfectly horizontal start, then smooth S-curve */}
        <path 
          d="M 4 110 C 40 110, 55 110, 70 110 C 85 111, 98 104, 108 94 C 113 89, 116 85, 118 81"
          stroke="#FFDD43" 
          strokeWidth="10" 
          strokeLinecap="round"
          fill="none"
        />
        {/* Arrow tip pointing left at x=4, y=110 - smooth curved style */}
        <path 
          d="M 14 103 Q 6 106, 4 110 Q 6 114, 14 117" 
          stroke="#FFDD43" 
          strokeWidth="10" 
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>

      {/* MIDDLE LAYER: Letters s, w, (Y space), p, e, r */}
      <g>
        {/* s - Shell Pink - moved 3px right total */}
        <text 
          x="1" 
          y="88" 
          fontFamily="'Baloo 2', 'Fredoka One', 'Bubblegum Sans', 'Comic Sans MS', cursive, sans-serif" 
          fontSize="64" 
          fontWeight="900"
          fill="#F88180"
          stroke="#E26B6A"
          strokeWidth="5"
          letterSpacing="2"
          paintOrder="stroke"
        >
          s
        </text>
        <ellipse cx="20" cy="62" rx="10" ry="15" fill="url(#glossy)" opacity="0.4"/>

        {/* w - White with dark stroke - positioned at x=33 */}
        <text 
          x="33" 
          y="88" 
          fontFamily="'Baloo 2', 'Fredoka One', 'Bubblegum Sans', 'Comic Sans MS', cursive, sans-serif" 
          fontSize="64" 
          fontWeight="900"
          fill="#FFFFFF"
          stroke="#888888"
          strokeWidth="5"
          letterSpacing="2"
          paintOrder="stroke"
        >
          w
        </text>
        <ellipse cx="68" cy="62" rx="10" ry="15" fill="url(#glossy)" opacity="0.3"/>

        {/* Left arm of Y - backslash connecting the swooshes - adjusted for raised swoosh */}
        <path 
          d="M 118 83 Q 106 67, 97 59 L 93 56"
          stroke="#FFDD43" 
          strokeWidth="10" 
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Space for Y formed by swooshes */}

        {/* p - Purple - moved 5px right total */}
        <text 
          x="150" 
          y="88" 
          fontFamily="'Baloo 2', 'Fredoka One', 'Bubblegum Sans', 'Comic Sans MS', cursive, sans-serif" 
          fontSize="64" 
          fontWeight="900"
          fill="#9B59B6"
          stroke="#6C3483"
          strokeWidth="5"
          letterSpacing="2"
          paintOrder="stroke"
        >
          p
        </text>
        <ellipse cx="172" cy="62" rx="10" ry="15" fill="url(#glossy)" opacity="0.4"/>

        {/* e - Emerald Green - moved 5px right total */}
        <text 
          x="190" 
          y="88" 
          fontFamily="'Baloo 2', 'Fredoka One', 'Bubblegum Sans', 'Comic Sans MS', cursive, sans-serif" 
          fontSize="64" 
          fontWeight="900"
          fill="#50C878"
          stroke="#2E7D52"
          strokeWidth="5"
          letterSpacing="2"
          paintOrder="stroke"
        >
          e
        </text>
        <ellipse cx="212" cy="62" rx="10" ry="15" fill="url(#glossy)" opacity="0.4"/>

        {/* r - Radical Red - moved 5px right total */}
        <text 
          x="228" 
          y="88" 
          fontFamily="'Baloo 2', 'Fredoka One', 'Bubblegum Sans', 'Comic Sans MS', cursive, sans-serif" 
          fontSize="64" 
          fontWeight="900"
          fill="#FF355E"
          stroke="#D91E3F"
          strokeWidth="5"
          letterSpacing="2"
          paintOrder="stroke"
        >
          r
        </text>
        <ellipse cx="248" cy="62" rx="10" ry="15" fill="url(#glossy)" opacity="0.4"/>
      </g>

      {/* TOP LAYER: Right swoosh - adjusted for raised bottom swoosh */}
      <g filter="url(#yShadow)">
        {/* Right arm flowing higher above the letters */}
        <path 
          d="M 118 81 L 123 71 C 130 58, 140 45, 155 38 C 170 31, 200 29, 246 33"
          stroke="#FFDD43" 
          strokeWidth="10" 
          strokeLinecap="round"
          fill="none"
        />
        {/* Arrow tip pointing right at x=246 - smooth curved style */}
        <path 
          d="M 236 26 Q 244 29, 246 33 Q 244 37, 236 40" 
          stroke="#FFDD43" 
          strokeWidth="10" 
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      
      {/* Gold circle to cover junction - smaller size */}
      <circle cx="118" cy="81" r="5" fill="#FFDD43" />
    </svg>
  );
};

export default SwyperLogo;
